import "materialize-css";

const ModalFooterDirective = function () {
    return {
        restrict: 'E',
        link: function (scope, elm, attr) {
            elm.addClass("modal-footer");
        }
    }
};

export { ModalFooterDirective };